<!-- <div class="card">
    <h4 class="card-header">Register</h4>
    <div class="card-body">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label for="firstName">First Name</label>
                <input type="text" formControlName="firstName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" />
                <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                    <div *ngIf="f.firstName.errors.required">First Name is required</div>
                </div>
            </div>
            <div class="form-group">
                <label for="lastName">Last Name</label>
                <input type="text" formControlName="lastName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" />
                <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                    <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                </div>
            </div>
            <div class="form-group">
                <label for="username">Email</label>
                <input type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                    <div *ngIf="f.email.errors.required">Email is required</div>
                </div>
            </div>
            <div class="form-group">
                <label for="password">Password</label>
                <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Password is required</div>
                    <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
                </div>
            </div>
            <div class="form-group">
                <button [disabled]="loading" class="btn btn-primary">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Register
                </button>
                <a routerLink="../login" class="btn btn-link">Cancel</a>
            </div>
        </form>
    </div>
</div> -->
<div class="register_block">
    <div class="container">
        <div class="reg_form">
           
            <div class="page-logo center">
                <img src="./../../assets/images/f_logo.png" width="150" class="responsive-img" alt="AutoConfig.com">
            </div>
            <div class="user-icon center">
                <img src="./../../assets/images/user.svg" width="100" class="responsive-img" alt="user">
            </div>
            <div class="title center"> Register</div>
            <form [formGroup]="form" (ngSubmit)="onSubmit()" class="formInput">
            
                <div class="row mb-0">
                    <div class="input-field _input-field col s12 m12 l12">
                        <label for="firstName">First Name</label>
                <input type="text" formControlName="firstName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" />
                <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                    <div *ngIf="f.firstName.errors.required">First Name is required</div>
                </div>
                
                       
                    </div>  
                   
                </div>
                <div class="row mb-0">
                    <div class="input-field _input-field col s12 m12 l12">
                        <label for="lastName">Last Name</label>
                        <input type="text" formControlName="lastName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" />
                        <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                            <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                        </div>
                    </div>  
                   
                </div>
                <div class="row mb-0">
                    <div class="input-field _input-field col s12 m12 l12">
                        <label for="username">Email</label>
                <input type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                    <div *ngIf="f.email.errors.required">Email is required</div>
                </div>
                    </div>  
                   
                </div>
             
                <div class="row">
                    <div class="input-field _input-field col s12 m12 l12">
                        <label for="password">Password</label>
                        <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.password.errors.required">Password is required</div>
                            <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
                        </div>
                    </div>  
                   
                </div>
                <div class="row mb-0"> 
                    <div class="login-btn col s12">
                        
                        <button [disabled]="loading" class="btn btn-orange register">
                            
                            Register
                        </button>
                    </div> 
                </div>
                <div class="center-align register-link">
                    Already have an account? <a routerLink="../login" class="link">Login</a> 
                </div>
            </form>
        </div>
    </div>
</div>
